import { Injectable, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { Router } from '@angular/router';
import { IMfeService } from '@mynexus/mfe-core';
import { BroadcastNoteService } from './broadcast.note.service';
import { Observable, of } from 'rxjs';
import { take, timeout, map, catchError } from 'rxjs/operators';
 
const DEACTIVATION_TIMEOUT_MS = 30000;
const CONFIRM_ACTION = {
  SAVE: 'save',
  DISCARD: 'discard',
  CANCEL: 'cancel'
} as const;
 
const componentMap = {
  "mnc-notes-sidebar": () => import("../../shared/notes-sidebar/notes-sidebar.component"),
  "mnc-notes-widget": () => import("../../shared/note-widget/note-widget.component"),
  "mnc-notes-account-notes": () => import("../../shared/notes/account-notes/account-notes/account-notes.component"),
  "mnc-notes-wound-tracker": () => import("../../shared/wound-tracker/wound-tracker.component"),
  "mnc-notes-member-level-of-function-table": () => import("../../shared/member-level-of-function-table/member-level-of-function-table.component"),
  "mnc-notes-create-button": () => import("../../shared/notes-create-button/notes-create-button.component"),
  "mnc-notes-view-button": () => import("../../shared/notes-view-button/notes-view-button.component"),
  "mnc-notes-pacim-sl-physician-p2p-note": () => import("../../shared/notes/pacim-service-lines-physician-peer-to-peer-note/pacim-service-lines-physician-peer-to-peer-note.component"),
}
 
@Injectable({
  providedIn: 'root'
})
export class NoteMfeService implements IMfeService {
  donePromise: Promise<boolean>;
  resolve: (value: boolean) => void;
 
  constructor(
    private router: Router,
    private injector: Injector,
    private broadcastNoteService: BroadcastNoteService
  ) {
    this.donePromise = new Promise<boolean>((resolve) => {
      this.resolve = resolve;
    });
  }
 
  navigate(path: string): void {
    this.router.navigate([path]);
  }
 
  loadComponent(name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        if(componentMap[name]){
          componentMap[name]().then(module => {
            customElements.define(
              name,
              createCustomElement<any>(module[Object.keys(module)[0]], { injector: this.injector })
            );
            resolve(true);
          });
        }else {
          reject('component not found');
        }
      }
      catch (error) {
        reject(error);
      }
    });
  }
 
  hasUnsavedChanges(): boolean {
    return this.broadcastNoteService.noteEditState$.getValue()?.isDirty ?? false;
  }
 
  requestDeactivationConfirm(): Observable<boolean> {
    this.broadcastNoteService.requestConfirmClose({});
 
    return this.broadcastNoteService.respondConfirmClose$.pipe(
      take(1),
      map(res => res.action !== CONFIRM_ACTION.CANCEL),
      timeout(DEACTIVATION_TIMEOUT_MS),
      catchError(() => of(false))
    );
  }
 
  closeAll(): void {
    this.broadcastNoteService.closeSidebar();
    this.broadcastNoteService.broadcastNotes(null, undefined);
    this.broadcastNoteService.setNoteEditState({
      noteId: null,
      isDirty: false,
      isInValid: false
    });
  }

  getNoteSidebarData(): any {
    return this.broadcastNoteService.getNoteSidebarData();
  }
}
 
